<template>
  <div class="home" :style="{ backgroundColor: bg, color: fg }" @click="onClick">
    <div class="header">
      <svg aria-hidden="true" data-prefix="fas" data-icon="seedling" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-seedling fa-w-16 fa-7x"><path fill="currentColor" d="M64 96H0c0 123.7 100.3 224 224 224v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C288 196.3 187.7 96 64 96zm384-64c-84.2 0-157.4 46.5-195.7 115.2 27.7 30.2 48.2 66.9 59 107.6C424 243.1 512 147.9 512 32h-64z" class=""></path></svg>
      <div>Conversation Seed</div>
    </div>
    <transition name="fade" mode="out-in">
      <div v-if="seedIndex" class="content" v-html="seeds[seedIndex].content" :key="seedIndex"></div>
    </transition>
    <transition name="fade" mode="out-in">
      <div v-if="seedIndex" class="attribution" :key="seedIndex">
        <div>seed pulled from:</div>
        <a :href="seeds[seedIndex].attribution" target="blank">{{ seeds[seedIndex].attribution }}</a></div>
    </transition>
  </div>
</template>

<script>
import colorable from 'colorable'
import ColorScheme from 'color-scheme'
import seeds from '../seeds.json'
export default {
  data () {
    return {
      colors: this.generateColors(),
      seeds: seeds,
      // seedIndex: this.randomSeedIndex(),
    }
  },

  computed: {
    seedIndex () {
      return this.$route.params.seedId
    },

    bg () {
      return this.colors[0]
    },

    fg () {
      return this.colors[1]
    }
  },

  watch: {
    seedIndex () {
      this.colors = this.generateColors()
    }
  },

  mounted () {
    if (!this.$route.params.seedId) {
      this.$router.push('/' + this.randomSeedIndex())
    }
  },

  methods: {
    randomSeedIndex () {
      return Math.floor(Math.random() * seeds.length)
    },

    onClick () {
      this.$router.push('/' + this.randomSeedIndex())
    },

    generateColors () {
      const scheme = new ColorScheme
      scheme.from_hue(Math.floor(Math.random() * 360))
      .scheme('contrast')
      .variation('pastel')

      const contrastData = colorable(scheme.colors().map(color => '#' + color), { compact: true, theshold: 4.5 })
      let highestContrastCombination = contrastData[0].combinations[0]
      contrastData[0].combinations.forEach(combination => {
        if (combination.contrast > highestContrastCombination.contrast) {
           highestContrastCombination = combination
        }
      })
      
      return [contrastData[0].hex, highestContrastCombination.hex]
    }
  }
}
</script>

<style lang="scss">
.home {
  background-color: #1a5761;
  color: #e2a59b;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  padding: 40px 15px;
  transition: background-color 1.2s, color 1.2s;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  a {
    color: inherit;
    
  }


}

.header {
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 0.05em;

  div {
    opacity: 0.3;
  }

  svg {
    height: 50px;
    width: 50px;
    opacity: 0.1;
  }
}

.content {
  font-size: clamp(24px, 10vw, 60px); 
  font-weight: 500;
  max-width: 800px;
  line-height: 1.2;
}

.attribution {
  font-size: 12px;
  font-weight: 100;
  max-width: 250px;

  div {
    opacity: 0.5;
  }

  a {
    line-break: anywhere;
    opacity: 0.3;
    text-decoration: none;
  }
}

.fade-enter-active {
  transition: opacity 0.6s 0.3s;
} 

.fade-leave-active {
  transition: opacity 0.6s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
